import React from "react";
import { FieldTemplateProps } from "@rjsf/utils";
import { useProfile } from "../ProfileProvider";

const CustomFieldTemplate = ({
  id,
  label,
  help,
  required,
  description,
  errors,
  children,
  uiSchema,
  schema,
}: FieldTemplateProps) => {
  // Use the custom title if provided, otherwise use empty
  const customTitle = uiSchema && uiSchema["ui:title"];
  const { theme } = useProfile();
  const isDarkMode = theme === "dark";

  // Add dark-mode class to the form-group element
  const formGroupClass = `form-group ${isDarkMode ? "dark-mode" : ""}`;

  // Use React.cloneElement to add dark-mode class to input elements
  const enhancedChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child as React.ReactElement<any>, {
        className: `${(child.props as any).className || ""} ${
          isDarkMode ? "dark-mode-input" : ""
        }`,
      });
    }
    return child;
  });

  // Check if it's a checkbox field to prevent duplicate descriptions
  const isCheckbox = schema.type === "boolean";

  return (
    <div className={formGroupClass}>
      {customTitle ? (
        <div>{customTitle}</div>
      ) : (
        <label htmlFor={id} className={isDarkMode ? "dark-mode-label" : ""}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      {description && !isCheckbox && (
        <div className="field-description">{description}</div>
      )}
      <div className={isDarkMode ? "dark-mode-field-container" : ""}>
        {enhancedChildren}
      </div>
      {errors}
      {help}
    </div>
  );
};

export default CustomFieldTemplate;
